import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ValueCard = ({ icon, heading, description }) => {
  return (
    <div className="w-full rounded overflow-hidden shadow-lg bg-white px-4 mx-auto text-center">
        <FontAwesomeIcon icon={icon} className="text-4xl text-emerald-600 mb-4" />
      <div className="px-6 py-1">
        <div className="font-semibold text-lg mb-4">{heading}</div>
        <p className="text-gray-500 text-md mb-4">{description}</p>
      </div>
    </div>
  );
};

ValueCard.propTypes = {
  heading: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  description: PropTypes.string.isRequired,
};

export default ValueCard;
